<template>
  <nav class="top-nav">
    <div style="cursor: pointer;" @click="$router.push('/')">
      <p style="font-family: 'Kaushan Script', cursive; color: orange; font-size: 18pt;">Vedic Astro Chart API Integration</p>
    </div>
  </nav>
  <div class="content-wrapper">
    <router-view />
  </div>
</template>

<style scoped>
.top-nav {
  background: #344E41;
  height: 65px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 2px 2px 2px 2px #A3B18A;
  position: sticky;
  top: 0;
  z-index: 1000;
  margin: 0;
  padding: 0;
}

.logo-image-style {
  width: 215px;
  height: 61px;
  cursor: pointer;
  display: block;
}

.content-wrapper {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

</style>
